import { render, staticRenderFns } from "./session_expire_modal.vue.js?vue&type=template&id=24e80716!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./session_expire_modal.vue?vue&type=template&id=24e80716"
import script from "./session_expire_modal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./session_expire_modal.vue?vue&type=script&lang=js"
export * from "./session_expire_modal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./session_expire_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e80716')) {
      api.createRecord('24e80716', component.options)
    } else {
      api.reload('24e80716', component.options)
    }
    module.hot.accept("./session_expire_modal.vue.js?vue&type=template&id=24e80716!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./session_expire_modal.vue?vue&type=template&id=24e80716", function () {
      api.rerender('24e80716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "authentication/sessions/components/session_expire_modal.vue"
export default component.exports